module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.11147/images/gswh-star.png"